import React from "react";
import { Phone, Mail, CalendarDays } from "lucide-react";
import SeoHead from "./SiteSeo";
import SiteLayout from "./SiteLayout";
import { CalendlyLink } from "./SiteHeader";
import { TopicBadge } from "./vaultBadges";
import { PHONE, PHONE_TEL, EMAIL, CALENDLY_URL } from "./nav";
import { FinalCta } from "./sections";

const BADGE = { word: "CALL ME MAYBE", img: "flipphone", left: "Hey, I just met you", right: "And this is crazy", line: "But here's our number" };

const WAYS = [
  { icon: CalendarDays, k: "Book a call", v: "15 minutes, your pick of time", href: CALENDLY_URL, cta: "Pick a time", calendly: true, id: "contact-book" },
  { icon: Phone, k: "Call", v: PHONE, href: PHONE_TEL, cta: "Call now", id: "contact-call" },
  { icon: Mail, k: "Email", v: EMAIL, href: `mailto:${EMAIL}`, cta: "Say hello", id: "contact-email" },
];

export default function ContactPage() {
  return (
    <SiteLayout>
      <SeoHead title="Contact Hello Mortgage Team | Call, Text, Email or Book a Call" description="Here's our number. Call, text, email or book a 15-minute call with the Hello Mortgage Team—Alberta mortgage brokers who answer in plain English." path="/contact/" />
      <section className="hero contact-hero" data-testid="contact-page">
        <div className="wrap">
          <TopicBadge badge={BADGE} />
          <p className="contact-lead" data-testid="contact-lead">But here's our number. Pick whichever way feels least like a phone call in 2004.</p>
        </div>
      </section>
      <section className="contact-ways">
        <div className="wrap contact-grid">
          {WAYS.map(({ icon: Icon, k, v, href, cta, calendly, id }) => (
            <div className="contact-card" key={k} data-testid={id}>
              <span className="contact-ic"><Icon size={22} strokeWidth={2} /></span>
              <span className="tag">{k}</span>
              <strong>{v}</strong>
              {calendly ? <CalendlyLink className="btn" testId={`${id}-cta`}>{cta}</CalendlyLink> : <a className="btn outline" href={href} data-testid={`${id}-cta`}>{cta}</a>}
            </div>
          ))}
        </div>
        <div className="wrap contact-fine">
          <p><b>What happens when you reach out:</b> We ask what you're trying to do, get you setup, run the numbers, and tell you the smartest next step—even if that step is "do nothing yet." Free, no pressure, no mortgage-speak.</p>
          <p className="micro">Hello Mortgage Team is powered by BRX Mortgage. Licensed in Alberta. We work with clients across the province by phone and video—no office visit required.</p>
        </div>
      </section>
      <FinalCta />
    </SiteLayout>
  );
}
